// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2C7Pv","footer":"ModalUpdate_footer__1M9X6"};